module.exports = __webpack_public_path__ + "static-portal/img/logo.757bb38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/logo.png
// module id = QQ3S
// module chunks = 4